import { render, staticRenderFns } from "./intel-promo-hero.vue?vue&type=template&id=abc2ac48&scoped=true&"
import script from "./intel-promo-hero.vue?vue&type=script&lang=js&"
export * from "./intel-promo-hero.vue?vue&type=script&lang=js&"
import style0 from "./intel-promo-hero.vue?vue&type=style&index=0&id=abc2ac48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc2ac48",
  null
  
)

export default component.exports